import { useNavigate, useParams } from "react-router-dom"

import { ReactComponent as IconDevice } from "assets/svg/icon-device.svg"
import { ReactComponent as IconSN } from "assets/svg/icon-sn.svg"
import { ReactComponent as IconTag } from "assets/svg/icon-tag.svg"

import { useCustomerDashboard } from "../../CustomerDashboardContext"
import {
  ContentItem,
  ContentText,
  IconWrapper,
  StyledWidgetButton,
  Widget,
  WidgetButton,
  WidgetContent,
  WidgetTitle,
} from "../styled"

export const DeviceDetailsWidget = () => {
  const { devices, currentDevice } = useCustomerDashboard()
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  const selectedDevice = devices[currentDevice]
  const convertedDevice = selectedDevice
    ? {
        address1: selectedDevice.address1 || "",
        address2: selectedDevice.address2 || "",
        deviceName: selectedDevice.name || "",
        serialNumber: selectedDevice.sn || "",
      }
    : null

  const handleSeeDetails = () => {
    navigate(`/customers/${id}/details`)
  }

  if (!convertedDevice) {
    return null
  }

  const fullAddress = [convertedDevice.address1, convertedDevice.address2].filter(Boolean).join(", ") || "-"

  return (
    <Widget>
      <WidgetTitle>Device Details</WidgetTitle>
      <WidgetContent>
        <ContentItem>
          <IconWrapper>
            <IconTag />
          </IconWrapper>
          <ContentText>{fullAddress}</ContentText>
        </ContentItem>
        <ContentItem>
          <IconWrapper>
            <IconDevice />
          </IconWrapper>
          <ContentText>{convertedDevice.deviceName || "-"}</ContentText>
        </ContentItem>
        <ContentItem>
          <IconWrapper>
            <IconSN />
          </IconWrapper>
          <ContentText>{convertedDevice.serialNumber || "-"}</ContentText>
        </ContentItem>
      </WidgetContent>
      <WidgetButton>
        <StyledWidgetButton onClick={handleSeeDetails} size="auto" color="blueBordered">
          See Details
        </StyledWidgetButton>
      </WidgetButton>
    </Widget>
  )
}
